import { Typography } from "@packages/ds";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Title = styled(Typography.Title)`
  display: flex;
  align-items: center;
`;

export const Default = styled.div`
  display: inline-block;
  margin: 0 0 0 8px;
  padding: 1px 8px 3px 8px;
  font-size: 12px;
  line-height: 20px;
  background: #efe7ff;
  border-radius: 2px;
  color: #9d67ff;
  ${semiBoldAlias()};
`;

export const FormWrapper = styled.form`
  padding: 32px;
  min-height: 200px;
  background-color: var(--section-snow-background-color, var(--snow));
`;

export const DeleteButtonWrapper = styled.div`
  margin-left: 16px;
`;

export const Text = styled.p`
  margin-top: 8px;
`;

export const EnvironmentContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 40px;
`;

export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
